import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_PAYMENT,  
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 60000
})

export default {
  async getPaymentDetails($payment_id) {    
    return await apiClient.get('/info/' + $payment_id);
  },
  async getBanks() {    
    return await apiClient.get('/banks');
  },
  async getBankAccountTypes($bankUid) {    
    return await apiClient.get('/bankAccountTypes/' + $bankUid);
  }
}